import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import CloseIcon from "@mui/icons-material/Close";
import FileUpload from "react-drag-n-drop-image";
import { toast } from "react-toastify";
import moment from "moment";

const getInternalPath = (clickType) => {
  const paths = {
    0: "/store",
    1: "/game",
    2: "/spin",
    3: "/refer",
    4: "/leaderboard",
    5: "/account",
    6: "/wallet",
    "0": "/store",
    "1": "/game",
    "2": "/spin",
    "3": "/refer",
    "4": "/leaderboard",
    "5": "/account",
    "6": "/wallet"
  };
  return paths[clickType] || "-";
};

const CustomBody = () => {
  return (
    <div
      className="drag-file-area mt-0"
      style={{
        border: "0px",
        borderRadius: "0px",
        width: "100%",
        position: "relative",
      }}
    >
      <div>
        <CloudDownloadIcon style={{ fontSize: "50px" }} />
      </div>
      <h3 className="dynamic-message" style={{ fontFamily: "Montserrat" }}>
        Drag &amp; drop any file here
      </h3>
      <label className="">
        <span className="">
          <span
            className="browse-files-text"
            style={{
              fontFamily: "Montserrat",
              color: "#539ffe",
            }}
          >
            browse file
          </span>
          <span style={{ fontFamily: "Montserrat" }}>from device</span>
        </span>
      </label>
    </div>
  );
};

function ShowData({ files, onRemoveImage }) {
  return (
    <div className="">
      {files.map((item) => {
        return (
          <>
            <div
              className="drag-file-area mt-0"
              style={{
                border: "0px",
                borderRadius: "0px",
                position: "relative",
              }}
            >
              <div className="d-flex" style={{ justifyContent: "center" }}>
                <div style={{ height: "200px", width: "200px" }} className="">
                  <img
                    src={item.preview}
                    alt="preview..."
                    height="100%"
                    width="100%"
                    style={{ objectFit: "contain" }}
                  />
                </div>
                <CloseIcon
                  style={{
                    cursor: "pointer",
                    color: "red",
                    position: "absolute",
                    right: 10,
                    top: 10,
                  }}
                  // onClick={() => {
                  //   setDragImage2(true);
                  //   setImage2(null);
                  // }}
                  onClick={() => onRemoveImage(item.id)}
                />
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
}

export default function Banner() {
  

  const { showPage, setShowPage, accessObject } = useAppContext();
  const { socket } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [imageFile, setImageFile] = React.useState();
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  console.log("files::: ", files);
  const [showImages, setShowData] = React.useState(false);
  const [isEditDataImage1, setIsEditDataImage1] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const LoginSchema = Yup.object().shape({
    url: Yup.string(),
    location: Yup.number().required("required"),
    bannerType: Yup.number().required("required"),
    type: Yup.number().required("required"),
    status: Yup.number().required("required"),
  });

  React.useEffect(() => {
    getBranch();
  }, []);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/banner/get-banner`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const IsEditOnRemoveImage = () => {
    setShowData(false);
    console.log("isEditOnRemove::: ");
    setFiles([]);
    setIsEditDataImage1(false);
  };

  const onRemoveImage = (id) => {
    setShowData(false);
    setFiles((prev) => prev.filter((i) => i.id !== id));
  };

  const onError = (error) => {
    console.error(error);
  };

  const onChange = (e) => {
    if (files.length === 0) {
      console.log(e[0].file.name, "true");
      setShowData(true);
      setImageFile(e[0].file);
      setFiles(e);
    }
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    setIsEditDataImage1(true);
    console.log("item edit value :::", item.imageName);
    console.log("value:::", item);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    console.log("imageFile :::", imageFile);
    setImageFile();
    setIsEditDataImage1(false);
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    console.log("updateTournament value :::", value);
    const body = {
      bannerAppType: parseInt(value?.bannerAppType),
      bannerClickType: parseInt(value?.bannerClickType),
      bannerType: parseInt(value?.bannerType),
      location: parseInt(value?.location),
      status: parseInt(value?.status),
      type: parseInt(value?.type),
      url: value?.url,
    };
    try {
      if (imageFile) {
        let img1FormData = new FormData();
        img1FormData.append("image", imageFile);

        axios(`${API_URL}/api/admin/banner/update-banner/${rowValue._id}`, {
          method: "PATCH",
          credentials: "include",
          data: img1FormData,
        })
          .then((result) => {
            if (result.data.status) {
              axios
                .patch(
                  `${API_URL}/api/admin/banner/update-banner/${rowValue._id}`,
                  body
                )
                .then((res) => {
                  if (res.data.status) {
                    successAdd(result.data.message);
                    setbuttonLoader(false);
                    socket.emit("bannerUpdate");
                  } else {
                    warningAlert();
                    setbuttonLoader(false);
                  }
                })
                .catch((err) => {
                  setbuttonLoader(false);
                  warningAlert();
                });
            }
          })
          .catch((err) => {
            console.log("handleSubmit err :::", err);
          });
      } else {
        axios
          .patch(
            `${API_URL}/api/admin/banner/update-banner/${rowValue._id}`,
            body
          )
          .then((res) => {
            if (res.data.status) {
              successAdd(res.data.message);
              setbuttonLoader(false);
            } else {
              warningAlert();
              setbuttonLoader(false);
            }
          })
          .catch((err) => {
            setbuttonLoader(false);
            console.log("update err :::", err);
            warningAlert();
          });
      }
    } catch (error) {
      console.log("error::: ", error);
    }
  };

  const addNewTournament = (value) => {
    const body = {
      bannerAppType: parseInt(value.bannerAppType),
      bannerClickType: parseInt(value.bannerClickType),
      bannerType: parseInt(value.bannerType),
      location: parseInt(value.location),
      status: parseInt(value.status),
      type: parseInt(value.type),
      url: value.url,
    };

    const formData = new FormData();

    // Append all body fields to formData
    Object.entries(body).forEach(([key, val]) => {
      formData.append(key, val);
    });

    // Append image file
    if (!imageFile) {
      toast.error("Image is required");
      setbuttonLoader(false);
      return;
    } else {
      formData.append("image", imageFile);
    }

    axios(`${API_URL}/api/admin/banner/add-banner`, {
      method: "POST",
      credentials: "include",
      data: formData,
    })
      .then((result) => {
        if (result.data.status) {
          // const formData = new FormData();
          // formData.append("banner-image", imageFile);

          // axios(
          //   `${API_URL}/api/admin/banner/upload-banner/${result.data.data._id}`,
          //   {
          //     method: "POST",
          //     credentials: "include",
          //     data: formData,
          //   }
          // )
          //   .then((result) => {
          //     if (result.data.status) {
          setbuttonLoader(false);
          socket.emit("bannerAdd");
          successAdd(result.data.message);
          //   } else {
          //     toast.error(result.data.message);
          //     setbuttonLoader(false);
          //   }
          // })
          // .catch((err) => {
          //   console.log("handleSubmit err :::", err);
          // });
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
        warningAlert();
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this banner record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title="Deleted!"
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        confirmBtnBsStyle="success"
      >
        Banner Deleted successfully...
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e===>", e._id);

    axios
      .delete(`${API_URL}/api/admin/banner/delete-banner/${e._id}`)
      .then((res) => {
        console.log(res);
        if (res.data.status) {
          successDeleted();
          socket.emit("bannerDelete");
        }
        getBranch();
      });
  };

  const successAdd = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The banner has been processed successfully."}</p>
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">Something went wrong. Please try again later.</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  url: rowValue ? rowValue?.url : "",
                  bannerClickType: rowValue ? rowValue?.bannerClickType : 0,
                  bannerType: rowValue ? rowValue?.bannerType : 0,
                  type: rowValue ? rowValue?.type : 1,
                  location: rowValue ? rowValue?.location : 0,
                  bannerAppType: rowValue ? rowValue?.bannerAppType : 0,
                  status: rowValue ? rowValue?.status : 0,
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  console.log("values...", values);
                  console.log("openValue...", openValue);

                  if (openValue === 1) {
                    console.log("update formik value :::", openValue);
                    addNewTournament(values);
                  }
                  if (openValue === 2) {
                    console.log("update formik value :::", openValue);
                    updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, values }) => (
                  <Form>
                    <div className="row">
                      {/* Banner Type Selection */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Banner Category <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="type"
                            className="mt-1 form-control"
                          >
                            <option value={0}>Internal (In-Game)</option>
                            <option value={1}>External (URL)</option>
                          </Field>
                        </div>
                      </div>

                      {/* Conditional URL or Click Type */}
                      <div className="col-md-6">
                        {parseInt(values?.type) === 1 ? (
                          <div className="form-group">
                            <label>External URL <span className="text-danger">*</span></label>
                            <Field
                              type="text"
                              name="url"
                              placeholder="https://example.com"
                              className={`mt-1 form-control ${touched.url && errors.url ? "is-invalid" : ""}`}
                            />
                            <ErrorMessage component="div" name="url" className="invalid-feedback" />
                          </div>
                        ) : (
                          <div className="form-group">
                            <label>In-Game Action <span className="text-danger">*</span></label>
                            <Field
                              as="select"
                              name="bannerClickType"
                              className="mt-1 form-control"
                            >
                              <option value={0}>Store</option>
                              <option value={1}>Game Name</option>
                              <option value={2}>Spin</option>
                              <option value={3}>Refer</option>
                              <option value={4}>Leaderboard</option>
                              <option value={5}>Account</option>
                              <option value={6}>Wallet</option>
                            </Field>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      {/* Location */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Display Location <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="location"
                            className={`mt-1 form-control ${touched.location && errors.location ? "is-invalid" : ""}`}
                          >
                            <option value={0}>Home Screen</option>
                            <option value={1}>Game Screen</option>
                            <option value={2}>Lobby Screen</option>
                          </Field>
                          <ErrorMessage component="div" name="location" className="invalid-feedback" />
                        </div>
                      </div>

                      {/* Display Mode */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Display Mode <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="bannerType"
                            className={`mt-1 form-control ${touched.bannerType && errors.bannerType ? "is-invalid" : ""}`}
                          >
                            <option value={0}>Banner (Small)</option>
                            <option value={1}>FullScreen (Interstitial)</option>
                          </Field>
                          <ErrorMessage component="div" name="bannerType" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* Target Platform */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Target Platform <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="bannerAppType"
                            className={`mt-1 form-control ${touched.bannerAppType && errors.bannerAppType ? "is-invalid" : ""}`}
                          >
                            <option value={0}>Play Store App</option>
                            <option value={1}>Custom App</option>
                            <option value={2}>Web Browser</option>
                          </Field>
                          <ErrorMessage component="div" name="bannerAppType" className="invalid-feedback" />
                        </div>
                      </div>

                      {/* Status */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Status <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="status"
                            className={`mt-1 form-control ${touched.status && errors.status ? "is-invalid" : ""}`}
                          >
                            <option value={0}>Active / ON</option>
                            <option value={1}>Inactive / OFF</option>
                          </Field>
                          <ErrorMessage component="div" name="status" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <label className="mb-2">Banner Creative <span className="text-danger">*</span></label>
                        {isEditDataImage1 ? (
                          <div className="file-upload-box border rounded p-3 text-center position-relative" style={{ backgroundColor: "#f8f9fa" }}>
                            <div className="d-inline-block position-relative">
                              <img
                                src={rowValue?.imageUrl}
                                alt="preview"
                                style={{ maxHeight: "200px", maxWidth: "100%", objectFit: "contain" }}
                              />
                              <CloseIcon
                                style={{
                                  cursor: "pointer",
                                  color: "white",
                                  backgroundColor: "#dc3545",
                                  borderRadius: "50%",
                                  padding: "2px",
                                  position: "absolute",
                                  right: "-10px",
                                  top: "-10px",
                                  fontSize: "20px"
                                }}
                                onClick={() => IsEditOnRemoveImage()}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="file-upload-box">
                            {showImages ? (
                              <ShowData files={files} onRemoveImage={onRemoveImage} />
                            ) : (
                              <FileUpload
                                onError={onError}
                                body={<CustomBody />}
                                overlap={false}
                                fileValue={files}
                                onChange={(e) => onChange(e)}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="d-flex mt-4 pt-2 border-top">
                      <button
                        style={{ width: "110px" }}
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={buttonLoader}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <b>Submit</b>
                          {buttonLoader && (
                            <div className="spinner-border ml-2" role="status" style={{ height: "16px", width: "16px" }} />
                          )}
                        </div>
                      </button>
                      <button
                        style={{ width: "110px" }}
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ms-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div className="card">
            <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
              <div className="row align-items-end">
                <div className="col-md-6 mb-3 mb-md-0">
                  {/* Empty space to align Add button to the right */}
                </div>
                <div className="col-md-6 text-right">
                  {accessObject?.bannerAdd === true && (
                    <button
                      onClick={() => {
                        openAddTournament(1);
                      }}
                      type="button"
                      className="btn btn-primary"
                    >
                      <AddIcon /> Add New
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th style={{ width: "250px" }}>Url</th>
                    <th>Location</th>
                    <th>Type</th>
                    <th>Click</th>
                    <th>Status</th>
                    {accessObject?.bannerEdit === true && <th>Action</th>}
                  </tr>
                </thead>
                {accessObject?.getBannerList === true ? (
                  <>
                    <tbody>
                      {!loader ? (
                        <>
                          {tableData.length > 0 ? (
                            <>
                              {tableData
                                ?.slice(pagination.start, pagination.end)
                                .map((item, index) => (
                                  <>
                                    <tr key={index}>
                                      <td>{index + 1 + pagination.start}</td>
                                      <td>
                                        {item.createdAt
                                          ? moment(item.createdAt).format("DD/MM/YYYY")
                                          : "-"}
                                      </td>
                                      <td
                                        style={{ maxWidth: "250px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                                        title={item.type === 0 ? getInternalPath(item.bannerClickType) : item.url}
                                      >
                                        {item.type === 0 ? getInternalPath(item.bannerClickType) : item.url}
                                      </td>
                                      <td>
                                        {item.location === 0
                                          ? "Home"
                                          : item.location === 1
                                            ? "Game"
                                            : item.location === 2
                                              ? "Lobby"
                                              : "-"}
                                      </td>
                                      <td>
                                        {item.bannerType === 0
                                          ? "Banner"
                                          : item.bannerType === 1
                                            ? "Full-Screen"
                                            : "-"}
                                      </td>
                                      <td>{item.clickCount}</td>
                                      <td>
                                        {item.status === 0
                                          ? "On"
                                          : item.status === 1
                                            ? "Off"
                                            : "-"}
                                      </td>
                                      <td className="d-flex justify-content-evenly ">
                                        {accessObject?.bannerEdit === true && (
                                          <EditIcon
                                            className="mr-3 courser"
                                            onClick={() =>
                                              clickEditButton(item)
                                            }
                                          />
                                        )}
                                        {accessObject?.bannerDelete ===
                                          true && (
                                            <ClearIcon
                                              className="courser text-danger"
                                              onClick={() =>
                                                warningWithConfirmMessage(item)
                                              }
                                            />
                                          )}
                                      </td>
                                    </tr>
                                  </>
                                ))}
                            </>
                          ) : (
                            <EmptyState colSpan={8} />
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </tbody>
                  </>
                ) : (
                  <>
                    <tr
                      style={{ backgroundColor: "rgba(0,0,0,.05)" }}
                      className="text-center"
                    >
                      <td colSpan={8}>
                        <h5>Access Denied</h5>
                      </td>
                    </tr>
                  </>
                )}
              </table>
              {accessObject?.getBannerList === true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getBannerList === true && tableData.length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
